import { DocDownload } from '@/common';

export const getBeautufiedFileSize = (bytes: number): string => {
  const kilobyte = 1024;
  const megabyte = kilobyte * 1024;

  if (bytes >= megabyte) {
    return `${(bytes / megabyte).toFixed(2)} MB`;
  }

  return `${(bytes / kilobyte).toFixed(2)} KB`;
};

export const getMegabytesFromBytes = (bytes: number): number => {
  return bytes / (1024 * 1024);
};

export const downloadFileFromDWS = async (response: DocDownload) => {
  const link = document.createElement('a');
  link.href = response.url;

  link.click();
  URL.revokeObjectURL(response.url);
};

export const downloadFileFromResponse = async (response: Response) => {
  const disposition = response.headers.get('Content-Disposition') || '';
  const filename = disposition.split('filename=')[1];
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  let fixed = filename;
  if (filename[0] === '"' && filename[filename.length - 1] === '"') {
    fixed = filename.slice(1, -1);
  }
  link.download = fixed;
  link.click();
  URL.revokeObjectURL(url);
};

/**
 * Merges two arrays of files and removes any duplicates
 * * Note: This function might be unoptimized when running on large sets of files,
 * refactor it to use mutation instead of spread operator if/when needed
 */
export const mergeFilesAndRemoveDuplicates = (previousFiles: File[], newFiles: File[]): File[] => {
  const mergedFiles = [...previousFiles];

  newFiles.forEach((newFile) => {
    const foundIndex = mergedFiles.findIndex((mergedFile) => mergedFile.name === newFile.name);

    if (foundIndex >= 0) {
      mergedFiles.splice(foundIndex, 1, newFile);
    } else {
      mergedFiles.push(newFile);
    }
  });

  return mergedFiles;
};
